import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const teamMembers = [
  {
    id: "shivdeep-mehta",
    name: "Shivdeep Mehta",
    role: "Founding Lawyer",
    title: "Barrister & Solicitor",
    image: "/images/lawyer.jpeg",
  },
  {
    id: "sakshi-doda",
    name: "Sakshi Doda",
    role: "Managing Lawyer",
    title: "Barrister & Solicitor",
    image: "/images/sakshii.jpg",
  }
];

const containerVariants = {
  animate: {
    transition: {
      staggerChildren: 0.16,
      delayChildren: 0.28
    }
  }
};

const cardVariants = {
  initial: { opacity: 0, y: 80, scale: 0.97 },
  animate: { opacity: 1, y: 0, scale: 1, transition: { type: "spring", bounce: 0.22, duration: 0.8 } }
};

export default function Team() {
  return (
    <div className="relative bg-white min-h-screen py-12 px-4 flex justify-center overflow-x-clip">
      {/* Soft background "blob" */}
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 w-[850px] h-[400px] bg-gradient-to-r from-blue-100 via-white to-blue-100 opacity-80 rounded-full blur-3xl z-0"
        aria-hidden="true"
      />
      <div className="relative max-w-6xl w-full z-10">
        <h2 className="text-4xl font-extrabold text-center mb-2">Our Team</h2>
        {/* Animated divider */}
        <div className="flex justify-center mb-8">
          <motion.div
            initial={{ opacity: 0, scaleX: 0.2 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 1, type: "spring" }}
            className="h-1 w-32 bg-gradient-to-r from-blue-400 to-blue-700 rounded-full"
          />
        </div>
        {/* <p className="text-center text-gray-500 mb-14 text-lg max-w-2xl mx-auto">
          Meet our passionate legal experts, dedicated to helping you with clarity, compassion, and unmatched experience.
        </p> */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 gap-20 place-items-center"
          variants={containerVariants}
          initial="initial"
          animate="animate"
        >
          {teamMembers.map((member, i) => (
            <motion.div
              key={member.id}
              variants={cardVariants}
              whileHover={{
                scale: 1.03,
                boxShadow: "0 10px 32px 0 rgba(36, 99, 235, 0.14), 0 1.5px 12px 0 rgba(36, 99, 235, 0.06)",
              }}
              transition={{ type: "spring", stiffness: 160, damping: 15 }}
              className="w-full max-w-xl"
            >
              <Link
                to={`/our-team/${member.id}`}
                className="block rounded-3xl bg-gray-50 hover:shadow-2xl shadow-lg p-16 group transition border border-gray-100 hover:border-blue-400"
                style={{ textDecoration: "none" }}
              >
                <div className="flex justify-center mb-10">
                  <motion.img
                    src={member.image}
                    alt={member.name}
                    className="w-60 h-72 object-cover rounded-2xl border-8 border-white shadow-lg group-hover:scale-105 transition-all duration-300"
                    whileHover={{ scale: 1.08 }}
                  />
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-gray-900 group-hover:text-blue-900 transition">
                    {member.name}
                  </div>
                  <div className="text-2xl font-bold text-yellow-600 mb-3">
                    {member.role}
                  </div>
                   <div className="text-2xl text-yellow-600 mb-1">
              {member.title}
            </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
